import { BtcGameBroadcast } from '@optools/services/operator-gateway/btc/types';
import { MediaType } from '@optools/services/operator-gateway/types/generated/graphql';

import { BroadcastFormValues } from '../schemas/broadcast';

export const sortBroadcasts = (a: BtcGameBroadcast, b: BtcGameBroadcast) => {
  const getPriority = (broadcast: BtcGameBroadcast) => {
    if (broadcast.mediaType === MediaType.VIDEO && broadcast.availableForStreaming) return 1;
    if (broadcast.mediaType !== MediaType.VIDEO && broadcast.availableForStreaming) return 2;
    if (broadcast.mediaType === MediaType.VIDEO && !broadcast.availableForStreaming) return 3;
    if (broadcast.mediaType !== MediaType.VIDEO && !broadcast.availableForStreaming) return 4;
    return 5;
  };

  return getPriority(a) - getPriority(b);
};

export type BroadcastFilter = Pick<
  BtcGameBroadcast,
  'availableForStreaming' | 'feedType' | 'language' | 'mediaType'
>;

export type BroadcastFilterKey = keyof BroadcastFilter;

export const matchesBroadcastFilters = (
  broadcast: BtcGameBroadcast,
  filters: Partial<BroadcastFilter>,
) => {
  const filterKeys = Object.keys(filters) as (keyof BroadcastFilter)[];
  if (filterKeys.length === 0) return true;

  return filterKeys.every((key) => {
    const filterValue = filters[key];
    const broadcastValue = broadcast[key];
    return filterValue === undefined || filterValue === broadcastValue;
  });
};

export const hasBroadcastUpdates = (broadcast: BtcGameBroadcast, values: BroadcastFormValues) => {
  return Object.entries(values).every(([key, value]) => {
    const broadcastValue = broadcast[key as BroadcastFilterKey];
    if (key === 'freeGameStatuses') {
      const freeGameStatuses = values.freeGameStatuses || [];
      return freeGameStatuses.every(({ freeGameType, status }) => {
        const broadcastStatus = broadcast.freeGameStatuses?.find(
          (s) => s.freeGameType === freeGameType,
        )?.status;
        return broadcastStatus === status;
      });
    }
    return broadcastValue === value;
  });
};
